import { api } from "@/lib/api";

export const APP_SHARE_URL = "https://clicouguardou.com.br";
export const APP_SHARE_TEXT = "Conheça o Clicou, Guardou! Um jeito simples de guardar o que importa e lembrar quando precisar.";

export async function shareApp() {
  if (navigator.share) {
    await navigator.share({ title: "Clicou, Guardou!", text: APP_SHARE_TEXT, url: APP_SHARE_URL });
    return "shared";
  }
  await navigator.clipboard.writeText(`${APP_SHARE_TEXT} ${APP_SHARE_URL}`);
  return "copied";
}

let vaultToken = null;
export const getVaultToken = () => vaultToken;
export const setVaultToken = (t) => { vaultToken = t; };
export const clearVaultToken = () => { vaultToken = null; };
export const vaultHeaders = () => ({ "X-Vault-Token": vaultToken || "" });

const b64uToBuf = (s) => Uint8Array.from(atob(s.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat((4 - (s.length % 4)) % 4)), (c) => c.charCodeAt(0)).buffer;
const bufToB64u = (b) => btoa(String.fromCharCode(...new Uint8Array(b))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

export const biometricSupported = async () => {
  if (!window.PublicKeyCredential) return false;
  try { return await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable(); } catch { return false; }
};

export async function registerBiometric() {
  const { data: opts } = await api.post("/vault/biometric/register-options", {}, { headers: vaultHeaders() });
  opts.challenge = b64uToBuf(opts.challenge);
  opts.user.id = b64uToBuf(opts.user.id);
  opts.excludeCredentials = (opts.excludeCredentials || []).map((c) => ({ ...c, id: b64uToBuf(c.id) }));
  const cred = await navigator.credentials.create({ publicKey: opts });
  const credential = {
    id: cred.id, rawId: bufToB64u(cred.rawId), type: cred.type, authenticatorAttachment: cred.authenticatorAttachment,
    response: { clientDataJSON: bufToB64u(cred.response.clientDataJSON), attestationObject: bufToB64u(cred.response.attestationObject), transports: cred.response.getTransports ? cred.response.getTransports() : [] },
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
  };
  return (await api.post("/vault/biometric/register", { credential }, { headers: vaultHeaders() })).data;
}

export async function unlockWithBiometric() {
  const { data: opts } = await api.post("/vault/biometric/auth-options");
  opts.challenge = b64uToBuf(opts.challenge);
  opts.allowCredentials = (opts.allowCredentials || []).map((c) => ({ ...c, id: b64uToBuf(c.id) }));
  const cred = await navigator.credentials.get({ publicKey: opts });
  const credential = {
    id: cred.id, rawId: bufToB64u(cred.rawId), type: cred.type, authenticatorAttachment: cred.authenticatorAttachment,
    response: { clientDataJSON: bufToB64u(cred.response.clientDataJSON), authenticatorData: bufToB64u(cred.response.authenticatorData), signature: bufToB64u(cred.response.signature), userHandle: cred.response.userHandle ? bufToB64u(cred.response.userHandle) : null },
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
  };
  return (await api.post("/vault/biometric/unlock", { credential })).data;
}

export async function saveToVault(items) {
  for (const it of items) {
    if (it.file) {
      const fd = new FormData();
      fd.append("file", it.file, it.file.name || "arquivo");
      fd.append("title", it.title || it.file.name || "Arquivo");
      await api.post("/vault/items/upload", fd, { headers: vaultHeaders() });
    } else {
      await api.post("/vault/items", { title: it.title, content: it.content || "" }, { headers: vaultHeaders() });
    }
  }
}
export const vaultTitle = (text, fallback = "Sem título") => (text || "").trim().split("\n")[0].slice(0, 80) || fallback;

export const ACCEPT_BY_CATEGORY = {
  image: "image/*",
  audio: "audio/*,.m4a,.mp3,.wav,.ogg",
  document: ".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.csv,.txt,.odt,.ods,.odp,application/pdf",
  video: "video/*,.mp4,.mov,.mkv,.webm",
};
export const acceptFor = (categories) => categories.map((c) => ACCEPT_BY_CATEGORY[c]).filter(Boolean).join(",");
export const FILE_LABELS = { image: "Foto", audio: "Áudio", document: "Documento", video: "Vídeo", text: "Texto" };
